// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-select {
  display: flex;
  align-items: center;
  min-width: 232px;
  cursor: pointer;
}
.company-select .placeholder {
  color: rgba(0, 0, 0, 0.65);
}
.company-select[disabled] {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.company-select[disabled] .placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.company-select-logo,
.company-select-logo-placeholder {
  flex-shrink: 0;
  min-width: 48px;
  max-height: 48px;
  width: auto;
  margin-right: 8px;
}
.company-select-logo-placeholder {
  background: #ccc;
  width: 48px;
  height: 48px;
}
.company-select svg.down {
  flex-shrink: 0;
  height: 12px;
  margin: 0 16px 0 auto;
  fill: currentColor;
}
.company-select-menu {
  display: flex;
  flex-direction: column;
  width: 480px;
  max-height: 480px;
  background: white;
  padding: 16px;
  box-shadow: 0px 0px 16px 0px #00000033;
}
.company-select-filter {
  margin: 0 0 8px 0;
}
.company-select-header {
  font-size: 16px;
  margin: 16px 0;
  padding: 0 16px;
}
.company-select-list-container {
  margin: 0 -16px -16px -16px;
  overflow: auto;
}
.company-select-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.company-select-list-item {
  display: flex;
  padding: 4px 24px;
  align-items: center;
  position: relative;
  background-color: transparent;
  transition: background-color 300ms;
  cursor: pointer;
}
.company-select-list-item:hover {
  background-color: rgba(0, 0, 0, 0.075);
}
.company-select-list-item-logo-container {
  overflow: hidden;
  text-align: center;
}
.company-name {
  flex: 1;
}
.company-select-name-container {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  line-height: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.company-select-name-container .company-select-solution {
  font-size: 10px;
  opacity: 0.6;
  margin-top: 6px;
}
.company-select-list-item-colors {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}
.company-select-list-item-logo-container {
  height: 3rem;
  width: 6rem;
  overflow: hidden;
  text-align: center;
}
.company-select-list-item-logo {
  height: 100%;
  width: auto;
  max-width: 100%;
  -o-object-fit: contain;
     object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./node_modules/.pnpm/@nackle+studio-tools@1.9.9_@types+react@18.3.12_antd@5.24.6_date-fns@2.30.0_moment@2.30.1_rea_phmwef3nwavhog6egt6kd254om/node_modules/@nackle/studio-tools/dist/components/company-select/company-select.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AACJ;AALA;EAOQ,0BAAA;AACR;AAEI;EACI,0BAAA;EACA,mBAAA;AAAR;AAFI;EAKQ,0BAAA;AAAZ;AAKA;;EAEI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AAHJ;AAMA;EACI,gBAAA;EACA,WAAA;EACA,YAAA;AAJJ;AAOA;EACI,cAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;AALJ;AAQA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,sCAAA;AANJ;AASA;EACI,iBAAA;AAPJ;AAUA;EACI,eAAA;EACA,cAAA;EACA,eAAA;AARJ;AAWA;EACI,2BAAA;EACA,cAAA;AATJ;AAYA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AAVJ;AAaA;EAEI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,kCAAA;EACA,eAAA;AAZJ;AAeA;EACI,sCAAA;AAbJ;AAgBA;EACI,gBAAA;EACA,kBAAA;AAdJ;AAiBA;EACI,OAAA;AAfJ;AAkBA;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAhBJ;AASA;EAUQ,eAAA;EACA,YAAA;EACA,eAAA;AAhBR;AAoBA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAlBJ;AAqBA;EACI,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAnBJ;AAsBA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;KAAA,mBAAA;AApBJ","sourcesContent":[".company-select {\n    display: flex;\n    align-items: center;\n    min-width: 232px;\n    cursor: pointer;\n\n    .placeholder {\n        color: rgba(0,0,0,.65);\n    }\n\n    &[disabled] {\n        color: rgba( 0, 0, 0, 0.25);\n        cursor: not-allowed;\n\n        .placeholder {\n            color: rgba( 0, 0, 0, 0.25);\n        }\n    }\n}\n\n.company-select-logo,\n.company-select-logo-placeholder {\n    flex-shrink: 0;\n    min-width: 48px;\n    max-height: 48px;\n    width: auto;\n    margin-right: 8px;\n}\n\n.company-select-logo-placeholder {\n    background: #ccc;\n    width: 48px;\n    height: 48px;\n}\n\n.company-select svg.down {\n    flex-shrink: 0;\n    height: 12px;\n    margin: 0 16px 0 auto;\n    fill: currentColor;\n}\n\n.company-select-menu {\n    display: flex;\n    flex-direction: column;\n    width: 480px;\n    max-height: 480px;\n    background: white;\n    padding: 16px;\n    box-shadow: 0px 0px 16px 0px #00000033;\n}\n\n.company-select-filter {\n    margin: 0 0 8px 0;\n}\n\n.company-select-header {\n    font-size: 16px;\n    margin: 16px 0;\n    padding: 0 16px;\n}\n\n.company-select-list-container {\n    margin: 0 -16px -16px -16px;\n    overflow: auto;\n}\n\n.company-select-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.company-select-list-item {\n    position: relative;\n    display: flex;\n    padding: 4px 24px;\n    align-items: center;\n    position: relative;\n    background-color: transparent;\n    transition: background-color 300ms;\n    cursor: pointer;\n}\n\n.company-select-list-item:hover {\n    background-color: rgba(0,0,0,.075);\n}\n\n.company-select-list-item-logo-container {\n    overflow: hidden;\n    text-align: center;\n}\n\n.company-name {\n    flex: 1;\n}\n\n.company-select-name-container {\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    line-height: 1;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n\n    .company-select-solution {\n        font-size: 10px;\n        opacity: .6;\n        margin-top: 6px;\n    }\n}\n\n.company-select-list-item-colors {\n    width: 24px;\n    height: 24px;\n    margin-right: 8px;\n}\n\n.company-select-list-item-logo-container {\n    height: 3rem;\n    width: 6rem;\n    overflow: hidden;\n    text-align: center;\n}\n\n.company-select-list-item-logo {\n    height: 100%;\n    width: auto;\n    max-width: 100%;\n    object-fit: contain;\n}\n\n@error-color: #EB0004;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
